export default "__VITE_ASSET__DpxDlQFa__"